import * as React from 'react';
import Typography from '@mui/material/Typography';

type HeadingProps = {
    // ...
} & { children: React.ReactNode };

export function Heading({ children }: HeadingProps) {
    return (
        <Typography
            variant="h1"
            sx={{
                fontSize: '24px',
                fontFamily: 'Gilroy'
            }}
        >
            {children}
        </Typography>
    );
}
